function getAppParamKey(appName, paramName) {
  return `${appName}.${paramName}`;
}

function _getByType(apps, checkInstalled = true, type) {
  return apps.filter((item) => {
    const isInstalled = checkInstalled ? item.installed() : true;
    const typeCheck = type === "ALL" ? true : item.get("type") === type;
    return isInstalled && typeCheck && !item.get("hide_on_ui");
  });
}

function getApps(apps, checkInstalled = true) {
  return _getByType(apps, checkInstalled, "APPLICATION");
}

function getAllApps(apps, checkInstalled = true) {
  return _getByType(apps, checkInstalled, "ALL");
}

export default {
  getApps,
  getAllApps,
};

export { getAppParamKey, getApps, getAllApps };
